import React, { useMemo } from 'react';
import {
  DIAS_CORTOS, DIAS_NOMBRE, claveEvento, diaDelMes, fmtHora, mismoMes, rejillaMes, textoDia,
} from '../../lib/calendario';
import { eventosDelDia, estiloEvento } from './disposicion';

const MAX_POR_DIA = 4;

/** Vista Mes: 6 semanas; cada día enseña sus primeros eventos y «N más» lleva a ese día. */
export default function VistaMes({ cursor, tz, hoy, preparados, colorDe, onCrear, onAbrir, onIrDia, compacto }) {
  const dias = useMemo(() => rejillaMes(cursor), [cursor]);
  const max = compacto ? 2 : MAX_POR_DIA;
  return (
    <div className="cal-mes" data-testid="cal-mes">
      <div className="cal-mes-cab">
        {DIAS_NOMBRE.map((d, i) => <span key={d}>{compacto ? DIAS_CORTOS[i] : d.slice(0, 3)}</span>)}
      </div>
      <div className="cal-mes-rejilla">
        {dias.map((d) => {
          const lista = eventosDelDia(preparados, d);
          const sobran = lista.length - max;
          return (
            <div
              key={d}
              className={`cal-mes-dia ${mismoMes(d, cursor) ? '' : 'is-fuera'} ${d === hoy ? 'is-hoy' : ''}`}
              onClick={(e) => {
                if (e.target.closest('.cal-ev, .cal-mes-num, .cal-mes-mas')) return;
                onCrear({ ymd: d, todoElDia: true, rect: e.currentTarget.getBoundingClientRect() });
              }}
            >
              <button type="button" className="cal-mes-num" onClick={() => onIrDia(d)} aria-label={textoDia(d, { weekday: 'long', day: 'numeric', month: 'long' })}>
                {diaDelMes(d) === 1 ? textoDia(d, { day: 'numeric', month: 'short' }).replace('.', '') : diaDelMes(d)}
              </button>
              <div className="cal-mes-eventos">
                {lista.slice(0, sobran > 0 ? max - 1 : max).map((p) => {
                  const ev = p.ev;
                  const relleno = p.banda || ev.solo_ocupado;
                  return (
                    <button
                      type="button"
                      key={`${claveEvento(ev)}-${d}`}
                      className={`cal-ev cal-mes-ev ${relleno ? 'is-banda' : ''}`}
                      style={relleno ? estiloEvento(ev, colorDe(ev)) : { '--ev': colorDe(ev), opacity: new Date(ev.fin) < Date.now() ? 0.66 : 1, textDecoration: ev.mi_estado === 'rechazado' ? 'line-through' : undefined }}
                      onClick={(e) => onAbrir(ev, e.currentTarget.getBoundingClientRect())}
                      data-testid="cal-evento"
                    >
                      {!relleno && <span className="cal-punto" style={{ background: ev.mi_estado === 'pendiente' ? 'transparent' : colorDe(ev), borderColor: colorDe(ev) }} />}
                      {!relleno && !compacto && <span className="cal-mes-hora">{fmtHora(ev.inicio, tz)}</span>}
                      <span className="truncate">{ev.titulo || '(Sin título)'}</span>
                    </button>
                  );
                })}
                {sobran > 0 && (
                  <button type="button" className="cal-mes-mas" onClick={() => onIrDia(d)}>
                    {sobran + 1} más
                  </button>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
